export default __webpack_public_path__ + "static/media/css3.9b31e2fd.svg";